export default function CustomEditController($q, $scope, $state, DataService, MapService, MapDrawService, NotificationService, TitleService) {
	"ngInject";

	const vm = this;

	vm.$onInit = () => {
		vm.customId = $state.params.customId;
		vm.loading = true;

		DataService.getCustom(vm.customId).then((custom) => {
			TitleService.setTitleTranslate("pros-maps.custom.edit.title", custom);

			vm.original = custom;
			vm.custom = angular.extend({}, vm.original);
			vm.map = DataService.instantMap();
			vm.recenter();

			DataService.setMapOpts({selectedOrg: vm.original});

			vm.loading = false;
		}, NotificationService.exception(vm));
	};

	vm.recenter = () => {
		MapService.centerMap(vm.custom, vm.map);
	};

	vm.save = () => {
		vm.loading = true;

		DataService.loadBoundary(vm.original).then((original) => (
			DataService.getMission().then((mission) => {
				vm.custom = angular.extend({}, original, vm.custom);
				return MapService.updateCustom(vm.custom, mission).then((custom) => (
					DataService.updateCustom(custom).then((custom) => {
						NotificationService.success("pros-maps.success.saved.custom", null, custom);
						vm.exit();
					})
				));
			})
		), NotificationService.exception(vm));
	};

	vm.remove = () => {
		vm.loading = true;

		MapService.deleteCustom(vm.original).then(() => (
			DataService.removeCustom(vm.original).then(() => {
				NotificationService.success("pros-maps.success.removed.custom", null, vm.original);
				vm.exit(true);
			})
		), NotificationService.exception(vm));
	};

	vm.exit = (home) => {
		if (home) {
			$state.go("mission");
		} else {
			$state.go("custom", {customId: vm.customId});
		}
	};
}
